// extracted by mini-css-extract-plugin
module.exports = {"title":"PointContent-module--title--1_zMQ","recyclingType":"PointContent-module--recyclingType--1pfSr","contactItem":"PointContent-module--contactItem--L0hlF"};